import { render, staticRenderFns } from "./HeaderOkr.vue?vue&type=template&id=f81a192e&scoped=true"
import script from "./HeaderOkr.vue?vue&type=script&lang=js"
export * from "./HeaderOkr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81a192e",
  null
  
)

export default component.exports